// About Section Data
// Edit this file to update the about section content

export const aboutData = {
  heading: "About Me",
  description: "I build secure, scalable cloud infrastructure on AWS and Azure — and extend it with AI. CI/CD pipelines, Kubernetes, Terraform, hardened EC2 deployments, and self-hosted LLM agents that plug into your existing tools. Infrastructure that doesn't just run — it thinks.",
  paragraphs: [
    "With hands-on experience in real-world production environments, I've worked extensively with Terraform to design reusable modules, automate cloud resources, and enforce best practices for security, networking, and scalability. My work spans Azure and AWS, where I've built and managed virtual networks, containerized workloads, CI/CD pipelines, monitoring stacks, and cloud security controls.",
    "I enjoy solving infrastructure challenges end-to-end—from architecture design and automation to deployment, monitoring, and cost optimization. I'm particularly driven by clean architecture, reproducible environments, and building systems that scale reliably while remaining easy to maintain. I'm always eager to deepen my cloud expertise and apply modern DevOps practices to impactful, real-world projects."
  ],
  stats: [
    {
      label: "Projects Completed",
      value: "15+"
    },
    {
      label: "Cloud Certifications",
      value: "2"
    },
    {
      label: "Years of Experience",
      value: "1+"
    },
    {
      label: "Technologies Mastered",
      value: "12+"
    }
  ]
};

